import PropTypes from 'prop-types';

import Box from 'shopper/components/Box';
import Tag from 'shopper/components/Tag/V1';

import toThreadText from 'lib/htmlParsers/parseThreadHtml';

import ThreadSocialMediaShare from './SocialMediaShare';

const ThreadMainContent = ({
  gaEventCategory,
  threadTags,
  threadText,
  threadTitle,
}) => (
  <Box className="mt-4 items-start rounded-t-none pt-6 md:pt-12" full>
    <div className="mb-10 flex max-w-full flex-1 flex-col break-words px-2 text-base text-neutral-low-100 dark:text-neutral-high-100 md:justify-between md:px-[120px]">
      {toThreadText(threadText)}
    </div>
    <div className="flex w-full items-center border-t border-solid border-neutral-high-200 px-2 py-4 dark:border-neutral-low-300 md:justify-end md:px-6">
      <div className="flex w-full flex-col md:flex-row md:justify-end lg:ml-24">
        {threadTags.length > 0 && (
          <div className="mr-4 flex w-full flex-wrap items-center gap-x-2">
            {threadTags.map(({ tagName, tagId }) => (
              <Tag key={tagId} filled>
                {tagName}
              </Tag>
            ))}
          </div>
        )}
        <ThreadSocialMediaShare
          gaEventCategory={gaEventCategory}
          threadTitle={threadTitle}
        />
      </div>
    </div>
  </Box>
);

ThreadMainContent.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  threadTags: PropTypes.arrayOf(
    PropTypes.shape({
      tagName: PropTypes.string,
      tagSlug: PropTypes.string,
      tagType: PropTypes.string,
      tagId: PropTypes.number,
    })
  ).isRequired,
  threadText: PropTypes.string.isRequired,
  threadTitle: PropTypes.string.isRequired,
};

export default ThreadMainContent;
